<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="明细列表" @click-left="onClickLeft" @click-right="goIndex()" />
    <van-collapse v-model="activeNames" accordion>
      <van-collapse-item v-for="(detail,index) in list" :name=index title="列表数据">
        <van-field v-model="detail.item.no" label="商品编号" name="商品编号" readonly />
        <van-field v-model="detail.item.name" label="商品名称" name="商品名称" readonly />
        <van-field v-model="detail.pack.specification" label="包装规格" name="包装规格" readonly />
        <van-field v-model="detail.asnDetail.lotNo" label="批号" name="批号" readonly />
        <van-field v-model="detail.asnDetail.manufacturer" label="生产厂家" name="生产厂家" readonly />
        <van-field v-model="detail.asnDetail.producingArea" label="产地" name="产地" readonly />
        <van-field v-model="detail.asnDetail.quantity" label="总数量" name="总数量" readonly />
        <van-field v-model="detail.asnDetail.receivedQuantity" label="收货数量" name="收货数量" readonly />
        <van-field v-model="detail.asnDetail.acceptedQuantity" label="验收数量" name="验收数量" readonly />
        <van-button type="primary" @click="itemClick(detail)">确认</van-button>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
  import { getUser } from '@/pdaView/utils'

  export default {
    data() {
      return {
        username: getUser().name,
        activeNames: [],
        list: []
      }
    },
    activated() {
      this.refresh()
    },
    methods: {
      goIndex() {
        this.$router.push({ name: 'PdaIndex' })
      },
      onClickLeft() {
        this.$router.back()
      },
      refresh() {
        this.list = this.$route.params.details
      },
      itemClick(data) {
        this.$router.push({ name: 'ReceiptSupervisionCode', params: { detail: data } })
      }
    }
  }
</script>